var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 30 28","fill":"none"}},[_c('path',{attrs:{"d":"M7 14H21M21 14L16 10M21 14L16 18","stroke":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }